import React, { useState, ChangeEvent } from 'react';

interface TextAreaProps {
  label: string;
  placeholder: string;
  id?: string;
  error?: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  required?: boolean;
}

const TextArea: React.FC<TextAreaProps> = ({ 
  label, 
  placeholder, 
  id, 
  error,
  value: controlledValue,
  onChange,
  onBlur,
  required = false
}) => {
  const textareaId = id || label.toLowerCase().replace(/\s+/g, '-');
  const [internalValue, setInternalValue] = useState('');
  
  // Use controlled value if provided, otherwise use internal state
  const value = controlledValue !== undefined ? controlledValue : internalValue;
  const isControlled = controlledValue !== undefined;

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const val = e.target.value;
    
    if (isControlled && onChange) {
      onChange(val);
    } else {
      setInternalValue(val);
    }
  };

  const handleBlur = () => {
    if (onBlur) {
      onBlur();
    }
  };

  return (
    <div>
      <label htmlFor={textareaId} className="mb-2.5 text-sm font-bold text-black block">
        {label}
        {required && <span className="text-red-600 ml-1">*</span>}
      </label>
      <textarea
        id={textareaId}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        required={required}
        className={`px-0 py-2.5 w-full border-b border-solid resize-none border-[none] h-[100px] ${
          error ? 'border-red-600' : 'border-b-black'
        }`}
      />
      {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default TextArea;